export default () => {
    const customProductSliders = document.querySelectorAll('.customProductSlider');
    if(!customProductSliders) return;
    customProductSliders.forEach(slider => {
        const splide = new window.splide(slider, {
            type: 'loop',
            fixedWidth: 320,
            padding: { right: 48 },
            rewind: true,
            gap: '20px',
            perMove: 1,
            pagination: false,
            arrows: true,
            interval: 2000,
            lazyLoad: 'nearby',
            breakpoints: {
                992: { arrows: false },
                576: { arrows: false, fixedWidth: 250 }
            }
        });


        function checkOverflow() {
            const track = splide.Components.Elements.track;

            const slides = splide.Components.Elements.slides;
            let totalWidth = slides.length * (splide.options.fixedWidth + parseInt(splide.options.gap, 10));
            let isOverflow = totalWidth > track.clientWidth;

            splide.options = {
                arrows: isOverflow,
                drag: isOverflow,
                clones: isOverflow ? undefined : 0,
                autoplay: isOverflow
            };

            splide.refresh();
        }

        splide.on('mounted', checkOverflow);
        splide.on('resize', checkOverflow);

        splide.mount();
    })
}